import { useTranslation } from "react-i18next";

export function ProductDetailsNoTerpenesInfo() {
	const { t } = useTranslation(["product"]);

	return (
		<p className="text-body-sm text-gray-500 mt-4 md:mt-6">
			{t("noTerpenesInformation")}
		</p>
	);
}
